<template>
  <div
    @click="viewDescription"
    class="
      border-2
      flex flex-col
      rounded-sm
      shadow-md
      text-gray-900
      overflow-hidden
    "
  >
    <div class="relative h-28">
      <img
        alt="image"
        class="h-2 w-2 animate-spin object-contain"
        src="@/assets/icons/spinner.svg"
      />

      <img
        alt="image"
        loading="lazy"
        v-if="imageUrl && imageUrl != 'placeholder'"
        :src="imageUrl"
        class="absolute top-0 h-28 object-cover w-full"
      />
      <img
        v-if="!imageUrl"
        alt="image"
        class="absolute top-0 h-28 object-contain bg-white w-full"
        src="@/assets/logograysquare.png"
      />
    </div>
    <p class="px-2 font-semibold text-left">
      {{ menuItem?.title }}
    </p>
    <div class="flex-1"></div>
    <p
      v-if="menuItem?.options"
      class="
        text-red-600
        font-medium
        border-b
        h-6
        text-sm
        bg-gray-50
        text-right
        ml-auto
        px-1
        flex
      "
    >
      Customize
    </p>
    <p class="text-right font-semibold pr-2 text-bnb-mustard">
      ₦ {{ menuItem?.price }}
    </p>
  </div>
</template>

<script>
import { Dialog } from "@capacitor/dialog";
import { Filesystem, Directory, Encoding } from "@capacitor/filesystem";

export default {
  props: {
    menuItem: Object,
  },
  created() {
    this.fetchCachedImage();
  },
  data() {
    return {
      imageUrl: "placeholder",
    };
  },
  methods: {
    fetchCachedImage() {
      var title = this.menuItem?.title;
      var urlImage = this.menuItem?.imageUrl;
      Filesystem.readFile({
        path: `menuImages/${title}`,
        directory: Directory.Data,
        encoding: Encoding.UTF8,
      })
        .then((result) => {
          this.imageUrl = result.data.slice(result.data.indexOf("data:image/"));
        })
        .catch((error) => {
          this.imageUrl = urlImage;
          console.log(error);
        });
    },
    viewDescription() {
      if (this.menuItem?.id) {
        try {
          var recentArray = JSON.parse(localStorage.recent);
          recentArray = recentArray.filter((e) => e != this.menuItem?.id);
          recentArray.unshift(this.menuItem?.id);
          localStorage.recent = JSON.stringify(recentArray.slice(0, 10));
        } catch {
          var newArray = [this.menuItem?.id];
          localStorage.recent = JSON.stringify(newArray);
        }
        this.$router.push({
          name: "MenuDescription",
          params: { menuID: this.menuItem?.id },
        });
      } else {
        Dialog.alert({ title: "Wait", message: "Item still loading" });
      }
    },
  },
};
</script>
